exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row.footer{margin:0;}\r\n.row.footer .col-md-12 {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left:0px;\r\n    background-color: #dfdfdf;\r\n    padding: 4px 20px;\r\n}\r\n.row.footer .col-md-12 label {\r\n    font-size: 11px;\r\n    font-weight: normal;\r\n}\r\nm-b-20\r\n{\r\nmargin-bottom:20px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/shared/footer/footer.css
// module id = 538
// module chunks = 3